/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Exit component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Exit({ title }) {
  return (
    <span className="svg svg-exit">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.828"
          height="14.829"
          viewBox="0 0 14.828 14.829"
        >
          <title>{title}</title>
          <g transform="translate(-138.086 -1252.086)">
            <line
              x1="12"
              y2="12"
              transform="translate(139.5 1253.5)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              x2="12"
              y2="12"
              transform="translate(139.5 1253.5)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Exit.propTypes = {
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Exit.defaultProps = {
  title: 'Exit',
};

export default Exit;
